import * as Dialog from "@radix-ui/react-dialog";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { ComponentProps, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "_shared/contexts/AuthContext";
import { useOpenTicket } from "_shared/contexts/OpenTicketContext";
import styles from "./MobileNav.module.scss";

// TODO: this component could be merged with the desktop version

interface Props {
  isAuthenticated: boolean;
}

const Link = (props: ComponentProps<RouterLink>) => {
  const location = useLocation();
  const isActive =
    (props.to === "/login" && location.pathname === "/") ||
    location.pathname.startsWith(props.to as string);

  return (
    <NavigationMenu.Link
      asChild
      active={isActive}
      data-testid="navlink"
      className={styles.link}
    >
      <RouterLink {...props} />
    </NavigationMenu.Link>
  );
};

function MobileNav({ isAuthenticated }: Props) {
  const [open, setOpen] = useState(false);
  const { toggleOpenTicket } = useOpenTicket();
  const { signOut } = useAuth();
  const { pathname } = useLocation();

  // close menu when route changes
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger
        className={styles.burgerButton}
        data-testid="nav-hamburger"
      >
        <i className="fas fa-bars" />
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Portal>
          <Dialog.Content className={styles.content}>
            <Dialog.Title>
              <VisuallyHidden asChild>Mobile nav</VisuallyHidden>
            </Dialog.Title>
            <Dialog.Close className={styles.close}>
              <i className="fas fa-times" />
            </Dialog.Close>
            <NavigationMenu.Root className={styles.nav}>
              {isAuthenticated ? (
                <NavigationMenu.List className={styles.list}>
                  <NavigationMenu.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </NavigationMenu.Item>
                  <NavigationMenu.Item>
                    <Link to="/account">Account</Link>
                  </NavigationMenu.Item>
                  <NavigationMenu.Item>
                    <button
                      data-testid="navlink"
                      className={styles.link}
                      onClick={() => {
                        toggleOpenTicket();
                        setOpen(false);
                      }}
                    >
                      Help ticket
                    </button>
                  </NavigationMenu.Item>
                  <NavigationMenu.Item>
                    <button
                      data-testid="navlink"
                      className={styles.link}
                      onClick={signOut}
                    >
                      Sign out
                    </button>
                  </NavigationMenu.Item>
                </NavigationMenu.List>
              ) : (
                <NavigationMenu.List className={styles.list}>
                  <NavigationMenu.Item>
                    <Link to="/login">Log in</Link>
                  </NavigationMenu.Item>
                  <NavigationMenu.Item>
                    <Link to="/signup">Sign up</Link>
                  </NavigationMenu.Item>
                </NavigationMenu.List>
              )}
            </NavigationMenu.Root>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default MobileNav;
